<script setup lang="ts">
import LeTopBanner from "@dsk/components/LeTopBanner.vue";

import { config } from "@/config";
import { Cookies } from "@/services";

/* eslint-disable @intlify/vue-i18n/no-raw-text */

const { site } = config.app;

const COOKIE_KEY = "skip-internal";
const COOKIE_VALUE = "true";

const onReturnClick = () => {
  const expires = new Date();
  expires.setDate(expires.getDate() + 1);
  expires.setHours(0, 0, 0);

  Cookies.set(COOKIE_KEY, COOKIE_VALUE, { expires });
};
</script>

<template>
  <LeTopBanner type="neutral">
    Du er på <a class="link" href="#">intern.{{ site }}.com</a> hvor du kan prøve nye funktioner af.
    <a class="link" :href="`//www.${site}.com`" @click="onReturnClick()">Vend tilbage til {{ site }}.com</a>
  </LeTopBanner>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";
</style>
